Analytics = require('common/debug/behavioral-analytics').default
{ PowerUp, PowerUpItemType } = require 'common/components/power-up'
{ atlassianPowerUps } = require 'data/directory'
BaseDirectoryView = require './base-directory-view'
c = require('views/internal/recup-with-helpers')('directory_data_consent')
notCompliantIcon = require 'images/directory/icons/notCompliant.svg'
compliantIcon = require 'images/directory/icons/compliant.svg'
{ ldclient } = require 'common/lib/ldclient'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginRunner = require 'views/internal/plugins/plugin-runner'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory_power_up_item')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
xtend = require 'xtend'

PermissionsList = c.renderable ({ pluginName }) ->
  c.div ->
    c.p ->
      c.format 'by-you-clicking-add', { pluginName }
    c.ul ->
      c.li ->
        c.format 'access-this-board'
      c.li ->
        c.format 'add-content-to-this-board-such-as-attachments-to-cards'
      c.li ->
        c.format 'take-actions-on-this-board-such-as-moving-sorting-filtering-cards-or-lists'
      c.li ->
        c.format 'access-user-information-such-as-username-avatar-initials-and-full-name-for-users-on-this-board'

PrivacyPolicy = c.renderable ({ pluginName, privacyPolicyUrl }) ->
  if privacyPolicyUrl
    return c.format 'for-more-information-please-see-power-ups-privacy-policy', {
      pluginName,
      privacyPolicyUrl
    }

  c.format 'for-more-information-please-see-power-ups-privacy-practices', { pluginName }

AtlassianDataConsent = c.renderable ({ pluginName, privacyPolicyUrl }) ->
  c.div '.directory-data-consent', ->
    c.p ->
      c.format 'power-up-is-developed-and-maintained-by-another-company-within-the-atlassian-corporate-family', { pluginName }
    c.tag PermissionsList, { pluginName }
    c.tag PrivacyPolicy, { pluginName, privacyPolicyUrl }

PersonalDataCompliance = c.renderable ({ pluginName, isCompliant }) =>
  c.div '.directory-compliance', ->
    c.p ->
      src = if isCompliant == false then notCompliantIcon else compliantIcon

      c.img '.directory-compliance-icon', { src, alt: "", role: "presentation" }
      if isCompliant == false
        c.format 'power-up-does-not-comply-with-our-data-privacy-standards', { pluginName }
      else if isCompliant == true
        c.format 'power-up-stores-data-complies-with-our-data-privacy-standards', { pluginName }
      else
        c.format 'power-up-complies-with-our-data-privacy-standards', { pluginName }

ThirdPartyDataConsent = c.renderable ({ pluginName, privacyPolicyUrl, isPublic, isCompliant }) ->
  c.div '.directory-data-consent', ->
    c.p ->
      c.format 'power-up-is-not-developed-or-maintained-by-trello', { pluginName }

    if isPublic && ldclient.variation('ecosystem.show_compliance_badge', false)
      c.tag PersonalDataCompliance, { pluginName, isCompliant }
    c.tag PermissionsList, { pluginName }
    c.tag PrivacyPolicy, { pluginName, privacyPolicyUrl }

module.exports = class DirectoryListingView extends BaseDirectoryView
  className: 'directory-listing-wrapper'

  eventSource: -> 'powerUpAddDetailsScreen'

  initialize: ({ @directoryView, @plugin, @currentPage }) ->
    super
    @io = PluginIOCache.get(@plugin)

  enable: (e) ->
    Util.stop(e)
    elem = e.target
    @model.enablePlugin(@plugin.id)

    trackUe(@currentPage, 'enables', 'Power-Up', '', '', 'enable button', @plugin.id)

    if @io.supports('on-enable')
      PluginRunner.one
        plugin: @plugin
        command: 'on-enable'
        board: @model
        el: elem
      .catch (err) =>
        console?.warn('Failed to handle on-enable command.', {
          error: err.message,
          id: @plugin.id
        })
      .finally =>
        @pluginEnabled()
    else
      @pluginEnabled()

  pluginEnabled: ->
    Analytics.sendTrackEvent
      action: 'added'
      actionSubject: 'powerUp'
      attributes: xtend @directoryView.getCommonTrackingAttributes(),
        powerUpName: if @plugin.get('public') then @io.getName() else undefined
      objectType: 'powerUp'
      objectId: @plugin.id
      source: 'addPowerUpButton'

    @directoryView.navigate({ idPlugin: @plugin.id })


  cancel: ->
    @directoryView.navigateBack()

  renderContent: t.renderable ->
    pluginName = @io.getName()
    iconUrl = @io.getIconUrl()
    author = @plugin.get('author')
    privacyPolicyUrl = @plugin.get('privacyUrl')
    isAtlassianOwned = @plugin.id in atlassianPowerUps
    isPublic = @plugin.get('public')
    isCompliant = @plugin.get('isCompliantWithPrivacyStandards')

    t.div '.directory-individual-listing', =>
      t.div '.directory-listing-powerup', =>
        t.tag PowerUp, {
          type: PowerUpItemType.Basic
          atomProps:
            subtitle: author
            icon:
              url: iconUrl
            name: pluginName
        }
      if isAtlassianOwned
        t.tag AtlassianDataConsent, {
          pluginName
          privacyPolicyUrl
        }
      else
        t.tag ThirdPartyDataConsent, {
          pluginName
          privacyPolicyUrl
          isPublic
          isCompliant
        }
      t.div '.directory-enable-page-buttons', =>
        t.button '.button.link', { onClick: @cancel.bind(@) }, ->
          t.formatText 'cancel'
        t.button '.button.primary', { onClick: @enable.bind(@) }, ->
          t.formatText 'add'
  render: ->
    super

    @directoryView.trackScreenEvent @eventSource(),
      powerUpId: @plugin.id

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-plugin-enable-view.coffee